<template>
  <v-app id="app">
    <Header/>
      <div class="main">
        <router-view/>
      </div>
    <Footer/>
  </v-app>
</template>

<script>
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'


export default{
  name:'App',
  components : {
  Header,
  Footer
}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat');
body {
  -background-color: #FFFFFA;
}
.v-application a {
  text-decoration: none !important;
  border-bottom: 1px solid white;
}
.v-application a:hover {
  border-bottom: 1px solid #ef4b47;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: justify;
  text-justify: inter-word;
  background-color: #FFFFFA;
  font-family: "Montserrat" !important;
  font-weight: bold;
  color: var(--unnamed-color-000000);
  overflow-x: hidden;
  font-size: 20px;
  height: 100%;
  line-height: 2rem;
}
body{
  padding: 0px;
  margin: 0px;
  height: 100%;
}
.main {
  display: flex;
  flex-direction: column;
  -background-color: #FFFFFA;
  background-image: url('~@/assets/Fondo.png');
  height: 100%;

}
.row{
  display: flex;
  flex-direction: row;
}
.column {
  display: flex;
  flex-direction: column;
}
.column-reverse{
  display: flex;
  flex-direction: column-reverse;
}
.row-reverse{
  display: flex;
  flex-direction: row-reverse;
}
.component-content{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15%;
  padding-right: 15%;
  overflow: visible;

}
.component-locale-text{
  padding-left: 5%;
  padding-right: 5%;
}
.main-component-container{
  padding-top: 7.5rem !important;
  -padding-top: 1.5rem !important;
    -padding-bottom: 5rem;
}
.component-title{
  margin: 2rem;
  justify-content: center;
}
.component-title-image{
  -padding-top: 2rem;
  height: auto;
  width: 555px;
}
.content-image{
  justify-content: center;
  display: flex;
  width: 80%;
  height: auto;
  align-self: center;
  overflow: hidden;
}
img {
  /* unused but necessary for inner images */
  max-width: 100%;
  max-height: 100vh;
}
.image {
  margin-left: 5rem;
}
hr{
  border: 1px solid #ef4b47;
  border-radius: 5px;
  width: 100%;
  /* -webkit-box-shadow: 0 2px 2px 1px #C96F2D;
  -moz-box-shadow: 0 2px 2px 1px #C96F2D;
  box-shadow: 0 2px 2px 1px #C96F2D; */
}

.bottom-corner-background-img{
  background-size: 35rem,auto;
  background-position: right -5rem bottom -5rem;
}

@media only screen and (max-width: 1024px) {
  .main-component-container{
    -padding-top: 4rem;
    padding-top: 8rem !important;
  }
  .bottom-corner-background-img{
    background-position: right -5rem bottom -5rem;
    background-size: 30rem,auto;
  }
  .content-image{
    width: 70%;
  }
}

@media only screen and (max-width: 750px) {
  #app {
    font-size: 16px;
  }
  .main-component-container{
    padding-top: 0 !important;
    padding-top: 6rem !important;
  }
  .component-content{
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 10%;
    padding-right: 10%;
  }
  .component-locale-text{
    padding-left: 0%;
    padding-right: 0%;
  }
  .main {

  }
  .content-image{
    width: 50%;
  }
  .image {
    margin-left: 0;
  }
  .bottom-corner-background-img{
    background-position: right -2rem bottom ;
    background-size: 15rem,auto;
  }
  .component-title{
    margin: 1rem;
  }
}
@media (max-width: 480px) {
  .bottom-corner-background-img{
    background-size: 12rem,auto;
  }
}
@media only screen and (max-width: 370) {
  .main {
    /*padding-top: 11.5rem;*/
  }

  .bottom-corner-background-img{
    background-position: right 0 bottom ;
    -background-size: 12rem,auto;
  }

}
</style>
